import React from "react";
import { Link } from "react-router-dom";
import { Wheat } from "lucide-react";
import Footer from "@/components/Footer";

const BG =
  "https://images.unsplash.com/photo-1511081692775-05d0f180a065?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxiYWtlcnklMjBjYWZlJTIwaW50ZXJpb3IlMjB3YXJtfGVufDB8fHx8MTc4NjkwMzQ3Mnww&ixlib=rb-4.1.0&q=85";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-brand-page">
      <div className="relative hidden lg:block grain overflow-hidden">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-brand-ink/45" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-10 w-10 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center border border-white/30">
              <Wheat className="w-5 h-5" />
            </div>
            <span className="font-display text-2xl">The Spread</span>
          </Link>
          <div>
            <p className="font-display text-4xl leading-tight">"When our standards are tight, our guests feel the difference."</p>
            <p className="mt-4 text-white/70">Private coaching for the Panera crew.</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md animate-fade-up">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-9 w-9 rounded-xl bg-brand flex items-center justify-center">
              <Wheat className="w-5 h-5 text-white" />
            </div>
            <span className="font-display text-2xl text-brand-ink">The Spread</span>
          </Link>
          <h1 className="font-display text-4xl tracking-tight text-brand-ink">{title}</h1>
          {subtitle && <p className="text-brand-muted mt-2">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-brand-muted">{footer}</div>}
          <div className="mt-10 border-t border-brand-line pt-4">
            <Footer compact />
          </div>
        </div>
      </div>
    </div>
  );
}
